import React from "react";
import useNonMember from "@icoach/nonMember/components/useNonMember";
import { RemoveTemparyCustomersDialog, AddInvalidDialog, NoMemberContactDialog, SendSmsDialog } from "@icoach/nonMember/dialog/";
import { MoreLabelBox } from "@icoach/components/";
import { Icons } from "@curves/ui-base";

export const NON_MEMBER_MORE_LABEL_MAP = {
	APPOINTMENT: "appointment",
	EDIT: "edit",
	SMS: "sms",
	CONTACT: "contact",
	INVALID: "invalid",
	REMOVE: "remove",
	REMOVETEMP: "removetemp",
	FOLDER: "folder",
};

const moreLabelMap = {
	edit: {
		text: "編輯",
		icon: <Icons.Edit />,
		to: ({ urls }) => `${urls["edit"]}`,
	},
	sms: {
		text: "發送簡訊",
		icon: <Icons.PaperPlane />,
		dialogString: NON_MEMBER_MORE_LABEL_MAP.SMS,
		Dialog: SendSmsDialog,
	},
	appointment: {
		text: "新增預約",
		icon: <Icons.Assignment />,
		to: ({ urls }) => `${urls["apo"]}`,
	},
	contact: {
		text: "新增聯繫",
		icon: <Icons.Phone />,
		dialogString: NON_MEMBER_MORE_LABEL_MAP.CONTACT,
		Dialog: NoMemberContactDialog,
	},
	onvalid: {
		text: "加入無效",
		icon: <Icons.UserSlash />,
		dialogString: NON_MEMBER_MORE_LABEL_MAP.INVALID,
		Dialog: AddInvalidDialog,
	},
	remove: {
		text: "刪除",
		icon: <Icons.Trash />,
		dialogString: NON_MEMBER_MORE_LABEL_MAP.REMOVE,
		// Dialog: RemoveCutomersDialog,
		Dialog: null,
	},
	removetemp: {
		text: "暫存刪除",
		icon: <Icons.Trash />,
		dialogString: NON_MEMBER_MORE_LABEL_MAP.REMOVETEMP,
		Dialog: RemoveTemparyCustomersDialog,
	},
};

const MoreLabel = props => {
	const { refresh } = useNonMember();
	return <MoreLabelBox {...props} refresh={refresh} moreLabelMap={moreLabelMap} />;
};

export default MoreLabel;
